/* 🤖 this file was generated by svg-to-ts */
export const matIconRemove: {
  name: 'remove';
  data: string;
} = {
  name: 'remove',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 13H5v-2h14v2z"/></svg>`
};
